import React, { useEffect, useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
    faUsers,
    faChurch,
    faCalendarAlt,
    // faPeopleArrows,
} from '@fortawesome/free-solid-svg-icons';
import Footer from "./Footer";
import Sidebar from "./sidebar";
import Topnav from "./TopNav";
import { API_URL } from "./config";
import { getCurrentDate } from './Components/DateFunction';
import { token } from './config';

const Dashboard = () => {
    const [memberCount, setMemberCount] = useState(0);
    const [visitorCount, setVisitorCount] = useState(0);
    const [ministryCount, setMinistryCount] = useState(0);
    const [ministryMemCount, setMinistryMemCount] = useState(0);
    const [eventCount, setEventCount] = useState(0);
    const [cellGroupCount, setCellGroupCount] = useState(0);
    const [cellGroupMemCount, setCellGroupMem] = useState(0);
    const [events, setEvents] = useState([]);
    const [show, setShow] = useState(false);

    const toggleSidebar = () => {
        setShow(prevShow => !prevShow); // Toggle the show state
    };

    useEffect(() => {
        const fetchCounts = async () => {
            try {
                const memberResponse = await fetch(`${API_URL}/members/all/Active`, {
                    headers: {
                        'Authorization': `Bearer ${token()}`
                    }
                });
                const members = await memberResponse.json();
                setMemberCount(members.length);

                const visitorResponse = await fetch(`${API_URL}/members/all/Visitor`, {
                    headers: {
                        'Authorization': `Bearer ${token()}`
                    }
                });
                const visitor = await visitorResponse.json();
                setVisitorCount(visitor.length);

                const ministryResponse = await fetch(`${API_URL}/ministries`, {
                    headers: {
                        'Authorization': `Bearer ${token()}`
                    }
                });
                const ministries = await ministryResponse.json();
                setMinistryCount(ministries.length);

                const ministryMemResponse = await fetch(`${API_URL}/ministrymembers`, {
                    headers: {
                        'Authorization': `Bearer ${token()}`
                    }
                });
                const ministryMem = await ministryMemResponse.json();
                setMinistryMemCount(ministryMem.length);

                const eventResponse = await fetch(`${API_URL}/events-tasks`, {
                    headers: {
                        'Authorization': `Bearer ${token()}`
                    }
                });
                const eventsData = await eventResponse.json();

                // Sort events by date and get the top 10 latest events

                // const sortedEvents = eventsData.sort((a, b) => new Date(b.Date) - new Date(a.Date)).slice(0, 10);
                // setEvents(sortedEvents);
                // setEventCount(sortedEvents.length);

                const sortedEvents = eventsData.sort((a, b) => new Date(b.Date) - new Date(a.Date)).slice(0, 10);
                let results = sortedEvents;
                results = results.filter(event => new Date(event.date.slice(0, 10)) >= new Date(getCurrentDate()));
                // console.log("Results: ",results[0].date.slice(0, 10));
                // console.log("Current date: ",getCurrentDate());
                setEvents(results);
                setEventCount(results.length);

                // Fetch cell groups count
                const cellGroupResponse = await fetch(`${API_URL}/smallgroups`, {
                    headers: {
                        'Authorization': `Bearer ${token()}`
                    }
                });
                const cellGroups = await cellGroupResponse.json();
                setCellGroupCount(cellGroups.length);

                const cellGroupMemResponse = await fetch(`${API_URL}/membersmallgrp`, {
                    headers: {
                        'Authorization': `Bearer ${token()}`
                    }
                });
                const cellGroupMem = await cellGroupMemResponse.json();
                setCellGroupMem(cellGroupMem.length);


            } catch (error) {
                console.error('Error fetching data:', error);
            }
        };

        fetchCounts();
    }, []);

    return (
        <html lang="en">
            <body>
                <div className="wrapper">
                    <Sidebar show={show} />
                    <div className="main-panel">
                        <Topnav toggleSidebar={toggleSidebar} />

                        <div className="container">
                            <div className="page-inner">
                                <div>
                                    <h2 style={{ textAlign: 'left' }}>Admin Dashboard</h2>
                                </div>
                                
                                <div class="row">
                                    <div class="col-sm-6 col-md-3">
                                        <div class="card card-stats card-round">
                                            <div class="card-body">
                                                <div class="row align-items-center">
                                                    <div class="col-icon">
                                                        <div
                                                            class="icon-big text-center icon-primary bubble-shadow-small"
                                                        >
                                                            {/* <i class="fas fa-users"></i> */}
                                                            <FontAwesomeIcon icon={faUsers} className="icon-xl" style={{ fontSize: '2.5rem', color: '#fff' }} />
                                                        </div>
                                                    </div>
                                                    <div class="col col-stats ms-3 ms-sm-0">
                                                        <div class="numbers">
                                                            <p class="card-category">Members</p>
                                                            <h4 class="card-title">{memberCount}</h4>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-sm-6 col-md-3">
                                        <div class="card card-stats card-round">
                                            <div class="card-body">
                                                <div class="row align-items-center">
                                                    <div class="col-icon">
                                                        <div
                                                            class="icon-big text-center icon-secondary bubble-shadow-small"
                                                        >
                                                            {/* <i class="far fa-check-circle"></i> */}
                                                            <FontAwesomeIcon icon={faUsers} className="icon-xl" style={{ fontSize: '2.5rem', color: '#fff' }} />
                                                        </div>
                                                    </div>
                                                    <div class="col col-stats ms-3 ms-sm-0">
                                                        <div class="numbers">
                                                            <p class="card-category">Visitors</p>
                                                            <h4 class="card-title">{visitorCount}</h4>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-sm-6 col-md-3">
                                        <div class="card card-stats card-round">
                                            <div class="card-body">
                                                <div class="row align-items-center">
                                                    <div class="col-icon">
                                                        <div
                                                            class="icon-big text-center icon-info bubble-shadow-small"
                                                        >
                                                            {/* <i class="fas fa-user-check"></i> */}
                                                            <FontAwesomeIcon icon={faChurch} className="icon-xl" style={{ fontSize: '2.5rem', color: '#fff' }} />
                                                        </div>
                                                    </div>
                                                    <div class="col col-stats ms-3 ms-sm-0">
                                                        <div class="numbers">
                                                            <p class="card-category">Ministries</p>
                                                            <h4 class="card-title">{ministryCount}</h4>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-sm-6 col-md-3">
                                        <div class="card card-stats card-round">
                                            <div class="card-body">
                                                <div class="row align-items-center">
                                                    <div class="col-icon">
                                                        <div
                                                            class="icon-big text-center icon-success bubble-shadow-small"
                                                        >
                                                            {/* <i class="fas fa-luggage-cart"></i> */}
                                                            <FontAwesomeIcon icon={faUsers} className="icon-xl" style={{ fontSize: '2.5rem', color: '#fff' }} />
                                                        </div>
                                                    </div>
                                                    <div class="col col-stats ms-3 ms-sm-0">
                                                        <div class="numbers">
                                                            <p class="card-category">Ministry Members</p>
                                                            <h4 class="card-title">{ministryMemCount}</h4>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-sm-6 col-md-3">
                                        <div class="card card-stats card-round">
                                            <div class="card-body">
                                                <div class="row align-items-center">
                                                    <div class="col-icon">
                                                        <div
                                                            class="icon-big text-center icon-secondary bubble-shadow-small"
                                                        >
                                                            {/* <i class="far fa-check-circle"></i> */}
                                                            <FontAwesomeIcon icon={faUsers} className="icon-xl" style={{ fontSize: '2.5rem', color: '#fff' }} />
                                                        </div>
                                                    </div>
                                                    <div class="col col-stats ms-3 ms-sm-0">
                                                        <div class="numbers">
                                                            <p class="card-category">Cell Groups</p>
                                                            <h4 class="card-title">{cellGroupCount}</h4>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-sm-6 col-md-3">
                                        <div class="card card-stats card-round">
                                            <div class="card-body">
                                                <div class="row align-items-center">
                                                    <div class="col-icon">
                                                        <div
                                                            class="icon-big text-center icon-primary bubble-shadow-small"
                                                        >
                                                            {/* <i class="fas fa-luggage-cart"></i> */}
                                                            <FontAwesomeIcon icon={faUsers} className="icon-xl" style={{ fontSize: '2.5rem', color: '#fff' }} />
                                                        </div>
                                                    </div>
                                                    <div class="col col-stats ms-3 ms-sm-0">
                                                        <div class="numbers">
                                                            <p class="card-category">Cell Members</p>
                                                            <h4 class="card-title">{cellGroupMemCount}</h4>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-sm-6 col-md-3">
                                        <div class="card card-stats card-round">
                                            <div class="card-body">
                                                <div class="row align-items-center">
                                                    <div class="col-icon">
                                                        <div
                                                            class="icon-big text-center icon-secondary bubble-shadow-small"
                                                        >
                                                            {/* <i class="far fa-check-circle"></i> */}
                                                            <FontAwesomeIcon icon={faCalendarAlt} className="icon-xl" style={{ fontSize: '2.5rem', color: '#fff' }} />
                                                        </div>
                                                    </div>
                                                    <div class="col col-stats ms-3 ms-sm-0">
                                                        <div class="numbers">
                                                            <p class="card-category">Events</p>
                                                            <h4 class="card-title">{eventCount}</h4>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                {/* END */}

                                <div className="row">
                                    <div className="col-md-12">
                                        <h3 style={{ textAlign: 'left' }}>Upcoming Events</h3>
                                        <div className="card">
                                            <div className="table-responsive pt-3">
                                                <table className="table table-striped events-table">
                                                    <thead>
                                                        <tr>
                                                            {/*<th>Event ID</th> */}
                                                            <th>Name</th>
                                                            <th>Description</th>
                                                            <th>Date</th>
                                                            <th>Time</th>
                                                            <th>Location</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {events.map(event => (
                                                            <tr key={event.EventID}>
                                                                {/* <td>{event.EventID}</td> */}
                                                                <td>{event.type}</td>
                                                                <td>{event.description}</td>
                                                                <td>{new Date(event.date).toLocaleDateString()}</td>
                                                                <td>{event.time}</td>
                                                                <td>{event.location}</td>
                                                            </tr>
                                                        ))}
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                        <footer className="footer">
                            <Footer />
                        </footer>
                    </div>
                </div>
            </body>
        </html>
    );
};

export default Dashboard;
